/**
 * Application Route Names
 * Centralized navigation route constants
 */

export const ROUTES = {
  // Auth Routes
  LOGIN: 'Login',
  REGISTER: 'Register',
  
  // Main Stack Routes
  MAIN_TABS: 'MainTabs',
  
  // Tab Routes
  QUOTES: 'Quotes',
  CHARTS: 'Charts',
  TRADES: 'Trades',
  HISTORY: 'History',
  HOME: 'Home',
  PROFILE: 'Profile',

  // Additional Screen Routes
  DEPOSIT: 'Deposit',
  WITHDRAWAL: 'Withdrawal',
  SETTINGS: 'Settings',
  DETAILS: 'Details',
};

export default ROUTES;
